(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroController', MacroController);

    MacroController.$inject = ['$stateParams', '$state', 'Macro', 'pagingParams', 'paginationConstants'];

    function MacroController($stateParams, $state, Macro, pagingParams, paginationConstants) {
        var vm = this;

        vm.macro = [];
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.loadAll = function() {
            var body = {
                id: -1,
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen
            };

            Macro.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.macro = data;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;

                for(var i = 0; i < data.length; i++){
                    if(!data[i].macroActions || data[i].macroActions.length === 0){
                        loadCommandsForGreengrassMacro(data[i]);
                    }
                }

                if(vm.macro.length == 0){
                    $state.go('action-commands', null, {reload: true});
                }
            }

            function loadCommandsForGreengrassMacro(macro) {
                Macro.getMacroDetails({macroId: macro.id}, function(queueCommands) {
                    macro.greengrassCommands = queueCommands;
                }, function(error) {
                    console.error('Error loading commands for macro:', macro.id, error);
                });
            }

            function onError() {}
        };

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();
    }
})();
